module.exports = __webpack_public_path__ + "static/media/26UNRWA13.273f9db1.jpg";